import { render, staticRenderFns } from "./SpeciesPage.vue?vue&type=template&id=3af855e4&"
import script from "./SpeciesPage.vue?vue&type=script&lang=js&"
export * from "./SpeciesPage.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports